<template>
  <el-dialog
    title="批量修改企业风控等级"
    :visible.sync="disabled"
    @close="close"
    width="700px"
  >
    <el-form :rules="rules" ref="form" :model="form">
      <el-table
        height="400px"
        :data="tableData"
        style="width: 100%"
        :cell-style="cellStyle"
        :header-cell-style="headerCellStyle"
      >
        <el-table-column prop="name" label="企业名称"></el-table-column>
        <el-table-column label="风控等级">
          <template slot-scope="scope">
            {{ scope.row.StormInfo.name || "" }}
          </template>
        </el-table-column>
      </el-table>
      <el-form-item :label="`共选择${tableData.length}个`" prop="num">
      </el-form-item>
      <el-form-item label="风控等级" prop="storm_id">
        <el-select
          style="width: 300px"
          v-model="form.storm_id"
          placeholder="请选择风控等级"
          filterable
        >
          <el-option
            v-for="(item, index) in StormTemp"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close" :loading="btnLoading">取 消</el-button>
      <el-button
        type="primary"
        @click="onDistribute('form')"
        :loading="btnLoading"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { postCompanyBatchUpdateAction } from "@/services/server/AccountInterface";
export default {
  props: {
    isShow: Boolean,
    rowData: Array,
  },
  data() {
    return {
      disabled: this.isShow,
      form: { id: "", storm_id: "" },
      tableData: [],
      StormTemp: [],
      btnLoading: false,
      rules: {
        storm_id: [
          { required: true, message: "请选择风控等级", trigger: "blur" },
        ],
      },
    };
  },
  async created() {
    this.StormTemp = this.$getDicByField("StormTemp");
    this.tableData = this.rowData;
    for (let i of this.rowData) {
      this.form.id += i.id + ",";
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    async onDistribute() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return;
        this.btnLoading = true;
        let res = await postCompanyBatchUpdateAction(this.form);
        this.btnLoading = false;
        if (res.code !== 200) return this.$message.error(res.message);
        this.$message.success("批量修改成功");
        this.close();
        this.$parent.esarchang();
      });
    },
    headerCellStyle() {
      return "text-align:center;background-color:#F2f2f2;";
    },
    cellStyle() {
      return "text-align:center;";
    },
  },
};
</script>

<style>
</style>